"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectTours = void 0;
const selectTours = (state) => state.toursReducer.tours;
exports.selectTours = selectTours;
